import moment from 'moment-timezone'

const paystub = () => {
  'ngInject'

  /**
   * Calculates the start date of a pay period given the ending date as the input
   */
  const calculateStartDate = (date) => {
    return moment(date).subtract(6, 'days').format('MM-DD-YYYY')
  }

  return {
    calculateStartDate
  }
}

export default paystub
